// src/features/tidsregistering/services/plannedShifts.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/tidsregistering/planned-shifts';

export const plannedShiftsAPI = {
  createShift: (data) =>
    apiClient.post(`${BASE}/`, data),

  listForDepartment: (startDate, endDate) =>
    apiClient.get(`${BASE}/department`, { params: { start_date: startDate, end_date: endDate } }),

  getShift: (plannedShiftId) =>
    apiClient.get(`${BASE}/${plannedShiftId}`),

  updateShift: (plannedShiftId, data) =>
    apiClient.put(`${BASE}/${plannedShiftId}`, data),

  deleteShift: (plannedShiftId) =>
    apiClient.delete(`${BASE}/${plannedShiftId}`),
};
